import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {DropDownList} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Input, InputChangeEvent} from "@progress/kendo-react-inputs"
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"
import {useCallback, useEffect, useRef, useState} from "react"
import {
    fetchMakeData,
    fetchModelData,
    fetchVehicleClassData,
    fetchVehicleType,
    getRegOrVin,
    RegOrVinData,
    resetVehicleSection,
    saveVehicleDetails,
    toggleModalPopup,
    VehicleDetail,
    vehicleInit,
} from "../../../containers/Vehicles/vehicleSlice"
import {RootState} from "../../../rootReducer"
import {CustomCalendar} from "../../../shared/CustomCalendar"
import {SpinnerFragment} from "../../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../../store"
import AlertToastr from "../../Shared/alertToastr"
import {PermissionsChecker} from "../../Shared/permissionChecker"

const AddVehicle = ({toggleDialog, hideAddDialog}: {toggleDialog: boolean; hideAddDialog: () => void}) => {
    const dispatch = useAppDispatch()
    const vehicleDetail = useAppSelector((state: RootState) => state.containers.vehicles.RegOrVinData)
    const regOrVinLoading = useAppSelector((state: RootState) => state.containers.vehicles.RegOrVinLoading)

    const makeList = useAppSelector((state: RootState) => state.containers.vehicles.makeList)
    const modelsList = useAppSelector((state: RootState) => state.containers.vehicles.modelsList)
    const vehicleType = useAppSelector((state: RootState) => state.containers.vehicles.vehicleTypes)
    const vehicleClass = useAppSelector((state: RootState) => state.containers.vehicles.vehicleClass)

    const loadingMakes = useAppSelector((state: RootState) => state.containers.vehicles.loadingMakes)
    const loadingModels = useAppSelector((state: RootState) => state.containers.vehicles.loadingModels)
    const loadingVehicleType = useAppSelector((state: RootState) => state.containers.vehicles.loadingVehicleType)
    const loadingVehicleClass = useAppSelector((state: RootState) => state.containers.vehicles.loadingVehicleClass)

    const savingVehicle = useAppSelector((state: RootState) => state.containers.vehicles.savingVehicle)
    const [vehicle, changeVehicleState] = useState<VehicleDetail>(vehicleInit())
    const vehicleHandleSubmit = (e: any) => {
        let data = {...e} as VehicleDetail
        dispatch(saveVehicleDetails(data))
    }

    useEffect(() => {
        if (toggleDialog) {
            dispatch(fetchMakeData())
            dispatch(fetchVehicleClassData())
            dispatch(fetchVehicleType())
        } else {
            dispatch(RegOrVinData(vehicleInit()))
        }
    }, [dispatch, toggleDialog])

    useEffect(() => {
        if (vehicle.make.length > 0) {
            dispatch(fetchModelData(vehicle.make))
        }
    }, [dispatch, vehicle.make])

    useEffect(() => {
        toggleDialog && formRef.current?.resetForm()
    }, [toggleDialog])

    useEffect(() => {
        changeVehicleState(vehicleDetail)
    }, [vehicleDetail])

    const formRef = useRef<any>()
    const regNumberField = useRef<any>()

    const resetVehicleData = () => {
        dispatch(resetVehicleSection(vehicle))
    }
    const onVechicleSearch = () => {
        const registration = regNumberField.current.value
        changeVehicleState({...vehicle, registration: registration})
        dispatch(getRegOrVin(registration))
    }

    const VehRegInput = (fieldRenderProps: FieldRenderProps) => {
        const {name, label, disabled} = fieldRenderProps
        const [vehicleNumber, setvehicleNumber] = useState<string>(vehicle.registration)
        const onValueChange = (event: InputChangeEvent) => {
            setvehicleNumber(event.value.replace(/\s/g, "").toUpperCase())
        }
        return (
            <Input
                id={`${name}`}
                ref={regNumberField}
                name={name}
                label={label}
                value={vehicleNumber}
                onChange={onValueChange}
                disabled={disabled}
            />
        )
    }
    const updateManufactureDate = (date: Date) => {
        changeVehicleState({
            ...formRef.current.values,
            manufactureDate: date,
        })
    }
    const updateRegistrationDate = (date: Date) => {
        changeVehicleState({
            ...formRef.current.values,
            registrationDate: date,
        })
    }
    const updateAnnualTestExpiryDate = (date: Date) => {
        changeVehicleState({
            ...formRef.current.values,
            annualTestExpiryDate: date,
        })
    }

    const CommonDropdownField = (fieldRenderProps: FieldRenderProps) => {
        const {name, label, value, data, onChange, disabled, loading} = fieldRenderProps
        const onValueChange = useCallback(
            event => {
                onChange(event.target.value)
                let updateVehicle = vehicle
                if (name === "make") {
                    updateVehicle = {...vehicle, [name]: event.target.value, model: ""}
                } else {
                    updateVehicle = {...vehicle, [name]: event.target.value}
                }
                changeVehicleState(updateVehicle)
            },
            [name, onChange],
        )

        return (
            <DropDownList
                required={name === "make"}
                value={value}
                id={`bkveh_dpdw_${name}`}
                onChange={onValueChange}
                data={data}
                label={label}
                disabled={disabled}
                loading={regOrVinLoading || loading}
            />
        )
    }

    const VehicleSection = ({vehicle}: {vehicle: VehicleDetail}) => {
        const disableVehicleInput =
            (vehicle.vehicleId > 0 && vehicle.dvsaFetchDate != null) || (vehicle.vehicleId === 0 && !vehicle.newVehicle)

        return (
            <>
                <div style={{display: "flex", alignItems: "flex-end"}}>
                    <Field
                        tabIndex={1}
                        name="registration"
                        component={VehRegInput}
                        label={"Vehicle"}
                        disabled={vehicleDetail.vehicleId > 0 || vehicle.newVehicle}
                    />
                    <button
                        tabIndex={2}
                        type="button"
                        className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-primary"
                        onClick={() => {
                            vehicleDetail.vehicleId > 0 || vehicle.newVehicle ? resetVehicleData() : onVechicleSearch()
                        }}
                    >
                        {vehicleDetail.vehicleId > 0 || vehicle.newVehicle ? (
                            <span className="k-icon k-i-close"></span>
                        ) : (
                            <span className="k-icon k-i-search"></span>
                        )}
                    </button>
                </div>
                <Field
                    tabIndex={3}
                    name="make"
                    component={CommonDropdownField}
                    label="Make"
                    data={makeList}
                    disabled={disableVehicleInput}
                    loading={loadingMakes}
                />
                <Field
                    tabIndex={3}
                    name="model"
                    component={CommonDropdownField}
                    label="Model"
                    data={modelsList}
                    disabled={disableVehicleInput}
                    loading={loadingModels}
                />
                <Field
                    tabIndex={4}
                    name="vehicleType"
                    component={CommonDropdownField}
                    label={"VehicleType"}
                    data={vehicleType.length === 0 ? [] : vehicleType}
                    disabled={disableVehicleInput}
                    loading={loadingVehicleType}
                />
                <Field
                    tabIndex={5}
                    name="vehicleClass"
                    component={CommonDropdownField}
                    label="Class"
                    data={vehicleClass.length === 0 ? [] : vehicleClass}
                    disabled={disableVehicleInput}
                    loading={loadingVehicleClass}
                />
                <Field
                    name="manufactureDate"
                    component={CustomCalendar}
                    updateDate={updateManufactureDate}
                    label="Manufactured"
                    disabled={disableVehicleInput}
                />
                <Field
                    name="registrationDate"
                    component={CustomCalendar}
                    updateDate={updateRegistrationDate}
                    label={"Registration"}
                    disabled={disableVehicleInput}
                />
                <Field
                    name="annualTestExpiryDate"
                    component={CustomCalendar}
                    updateDate={updateAnnualTestExpiryDate}
                    label={"Annual Test Exp."}
                    disabled={disableVehicleInput}
                />
            </>
        )
    }

    return (
        <>
            <AlertToastr />
            <MDBModal staticBackdrop show={toggleDialog} animationDirection="right" tabIndex="-1">
                <MDBModalDialog position="top right" side>
                    <MDBModalContent className="full-height ">
                        <MDBModalHeader>
                            <MDBModalTitle>Vehicle</MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => dispatch(toggleModalPopup(false))}
                            ></MDBBtn>
                        </MDBModalHeader>
                        {(regOrVinLoading || savingVehicle) && <SpinnerFragment />}
                        {toggleDialog && (
                            <Form
                                key={JSON.stringify(vehicle)}
                                initialValues={vehicle}
                                onSubmit={vehicleHandleSubmit}
                                ref={formRef}
                                ignoreModified
                                render={(formRenderProps: FormRenderProps) => (
                                    <FormElement className="w-100">
                                        <Toolbar className="shadow-0 border-bottom p-0 pt-1 ps-1 pb-1 position-sticky top-0">
                                            <ToolbarItem>
                                                <PermissionsChecker permission={["Vehicles.Edit"]}>
                                                    <Button
                                                        disabled={
                                                            !formRenderProps.valid ||
                                                            (vehicle.vehicleId > 0 && vehicle.dvsaFetchDate != null)
                                                        }
                                                        type="submit"
                                                        fillMode={"flat"}
                                                        themeColor="primary"
                                                        iconClass="fa fa-save"
                                                    >
                                                        Save
                                                    </Button>
                                                </PermissionsChecker>
                                            </ToolbarItem>
                                        </Toolbar>
                                        <MDBModalBody className="modal-overflow">
                                            <fieldset className={"k-form-fieldset mt-0"}>
                                                <Input name="vehicleId" type="hidden" />
                                                <MDBRow>
                                                    <MDBCol>
                                                        <VehicleSection vehicle={vehicle} />
                                                    </MDBCol>
                                                </MDBRow>
                                            </fieldset>
                                        </MDBModalBody>
                                    </FormElement>
                                )}
                            />
                        )}
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

export default AddVehicle
